import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;
const BASE_URL = `${API_URL}Invoice`;

export const invoiceService = {
    /**
     * Pobiera listę faktur z paginacją i filtrami.
     */
    getInvoices(params = {}) {
        return axios.get(BASE_URL, { params });
    },

    /**
     * Pobiera szczegóły faktury po ID.
     */
    getInvoice(id) {
        return axios.get(`${BASE_URL}/${id}`);
    },

    /**
     * Pobiera fakturę przypisaną do zamówienia.
     *
     * 200 - faktura istnieje
     * 404 - faktura nie istnieje
     */
    getInvoiceByOrderId(orderId) {
        return axios.get(`${BASE_URL}/by-order/${orderId}`);
    },

    /**
     * Tworzy fakturę na podstawie zamówienia.
     */
    createFromOrder(orderId) {
        return axios.post(`${BASE_URL}/from-order/${orderId}`);
    },

    /**
     * Wystawia fakturę.
     */
    issueInvoice(id) {
        return axios.post(`${BASE_URL}/${id}/issue`);
    },

    /**
     * Pobiera PDF faktury jako Blob.
     */
    getInvoicePdf(id) {
        return axios.get(`${BASE_URL}/${id}/pdf`, {
            responseType: "blob",
        });
    },

    deleteInvoice(id) {
        return axios.post(`${BASE_URL}/deleteinvoice`, {
            id: id,
        });
    },

    /**
     * Otwiera PDF faktury w nowej karcie przeglądarki.
     */
    async openInvoicePdf(id) {
        const response = await this.getInvoicePdf(id);

        const fileUrl = URL.createObjectURL(
            new Blob([response.data], {
                type: "application/pdf",
            })
        );

        window.open(fileUrl, "_blank", "noopener,noreferrer");

        // Zwalnia zasoby po 60 sekundach.
        window.setTimeout(() => {
            URL.revokeObjectURL(fileUrl);
        }, 60_000);
    },

    // Synchronizacja faktury z inFakt.
    syncWithInFakt(id) {
        return axios.post(`${BASE_URL}/${id}/sync/infakt`);
    },

    // Sprawdzenie statusu zadania inFakt.
    refreshInFaktStatus(id) {
        return axios.post(`${BASE_URL}/${id}/sync/infakt/status`);
    },

    createCorrectionFromOrder(orderId) {
        return axios.post(
            `${BASE_URL}/correction-from-order/${orderId}`
        );
    },
};

export default invoiceService;